import { Field } from "formik";
import React from "react";
import { ColorRing } from 'react-loader-spinner';
import styled from "styled-components";
import { mobileAndDown, tabletAndDown } from "../utils/styleUtils";

export const MobileSeparator = styled.div`
    display: none;
    ${tabletAndDown(`
        display: block;
        min-width: 100%;
    `)}
`;
export const Portal = styled.div`
    position: relative;
    width: 300px;
    height: 630px;
    background-image: url(/iPhone11Pro.png);
    background-size: cover;
    padding: 13px;
    justify-self: start;
    ${mobileAndDown`
        margin: 0 auto;
        width: 240px;
        height: 510px;
    `}
`;
export const CodeSection = styled.div`
    height: 320px;
    width: 284px;
    margin: 40px 7px 0;
    overflow-x: scroll;
    background-color: rgb(29, 31, 33);
    ${({ loading }) => (loading ? "opacity: 0.75;" : "")}
    ${({ locked }) => (locked ? "overflow-y: hidden;" : "")}
    > pre {
        margin-top: 0 !important;
        margin-bottom: 0 !important;
        width: fit-content;
        overflow-x: hidden !important;
        // GEOFF - You can change the code font-size here. Don't forget to update PX_PER_LINE accordingly
        font-size: 9px;
        > code > .selected-row {
            background-color: rgb(156, 256, 156, 0.3);
            display: block;
        }
        ${({ readonly }) =>
            readonly
                ? ""
                : `
            > code > .react-syntax-highlighter-line-number {
                cursor: pointer;
                :hover {
                    filter: brightness(2);
                }
            }
        `}
    }
    ${mobileAndDown`
        height: 250px;
        width: 232px;
        margin: 48px 3px 0 3px;
    `}
`;

export const MainSection = styled.div`
    font-family: SF Pro Display, Suisse-Regular;
    grid-row: 1 / 2;
    grid-column: 1 / 2;
    padding: 0 2rem 2rem 4rem;
    ${mobileAndDown`
        padding: 0 1rem 0 1rem;
    `}
`;

export const PortalSection = styled.div`
    position: relative;
    grid-row: 1 / 3;
    grid-column: 2 / 3;
    display: flex;
    ${mobileAndDown`
        grid-row: 2 / 3;
        grid-column: 1 / 2;
    `}
`;

export const Background = styled.div`
    background-image: url(${({ image }) => image});
    background-size: cover;
    margin: 60px 8px;
    height: 395px;
    width: 282px;
    ${mobileAndDown`
        height: 316px;
        width: 231px;
        margin: 48px 4px;
    `}
`;

export const RightSection = styled.div`
    display: flex;
    flex-direction: column;
    ${mobileAndDown`
        position: absolute;
        right: 0;
        bottom: 165px;
    `}
`;
export const StepTitle = styled.h1`
    font-family: Circular-Bold;
    font-size: 50px;
    ${mobileAndDown`
        font-size: 35px;
        margin-top: 0;
    `}
`;
export const StepHint = styled.h2`
    font-family: Circular-Book;
    font-size: 25px;
    color: #c4c4c4;
    margin-right: 3rem;
    ${mobileAndDown`
        font-size: 20px;
        padding: 0;
        margin-right: 0;
    `}
`;
export const Card = styled.div`
    background-color: #e7e7e7;
    border-radius: 10px;
    margin: 24px;
    padding: 24px;
`;

export const Label = styled.label`
    margin-top: 0.8rem;
    font-family: Circular-Bold;
    font-size: 12px;
    width: 60px;
`;

export const Slider = styled(Field)`
    width: 227px !important;
    margin: 1rem 0 !important;
    -webkit-appearance: none;
    background-color: #222222;
    height: 0.25rem !important;
    outline: none;
`;

const VerticalSliderContainer = styled.div`
    position: absolute;
    top: 0px;
    left: 340px;
    height: 656px;
    width: 50px;
    > div {
        transform: scale(0);
        transform-origin: left;
        transition: transform 0.2s ease-in;
    }
    &:hover {
        > div {
            transform: scale(1.5);
        }
    }
    ${mobileAndDown`
        left: 0px;
        top: -50px;
        grid-row: 1 / 2;
        grid-column: 3 / 4;
    `}
`;

const StyledVerticalSlider = styled.input`
    transform: rotate(90deg);
    position: absolute;
    top: 50%;
    left: calc(100% - 145px);
    margin-right: 2px !important;
    width: 300px !important;
    cursor: pointer;
    -webkit-appearance: none;
    background-color: #222222;
    height: 0.25rem !important;
    outline: none;
    ${mobileAndDown`
        left: -140px;
        top: 50%;
        grid-row: 1 / 2;
        grid-column: 3 / 4;
    `}
`;

const VerticalSliderLabel = styled.div`
    ${({ max, value }) => (!max && !value ? "display: none;" : "")}
    position: absolute;
    top: calc(180px + ${({ max, value }) => (285 / max) * Number(value)}px);
    left: 90px;
    background-color: #3b9af8;
    font-family: Circular-Bold;
    color: #ffffff;
    width: 20px;
    height: 20px;
    line-height: 20px;
    font-size: 14px;
    text-align: center;
    border-radius: 50%;
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.75);
    :before {
        content: "";
        position: absolute;
        width: 10px;
        top: 5px;
        height: 10px;
        transform: rotate(45deg);
        background-color: #3b9af8;
        left: -2px;
        z-index: -1;
    }
    ${mobileAndDown`
        width: 15px;
        height: 15px;
        left: 30px;
        line-height: 15px;
        font-size: 8px;
        right: -40px;
        :before {
            left: -1px;
            width: 5px;
            height: 5px;
        }
    `}
`;

export const VerticalSlider = ({ max, value = 0, onChange }) => (
    <VerticalSliderContainer>
        <StyledVerticalSlider
            type="range"
            max={max}
            value={value}
            onChange={(e) => onChange(Number(e.target.value))}
        />
        <VerticalSliderLabel max={max} value={value}>
            {Number(value) + 1}
        </VerticalSliderLabel>
    </VerticalSliderContainer>
);

export const Button = styled.button`
    background-color: #2660f5;
    color: #ffffff;
    height: 50px;
    font-weight: 600;
    font-size: 18px;
    min-width: 120px;
    white-space: nowrap;
    margin: 0.5rem;
    border-radius: 10px;
    cursor: pointer;
    outline: 0;
    border-style: solid;
    &:focus {
        outline: 0;
    }
`;

export const TipText = styled.div`
    height: 245px;
    width: 268px;
    padding: 8px;
    margin: 0 7px 0 7px;
    font-family: SF Pro Display, Suisse-Regular;
    font-size: 15px;
    line-height: 21.3px;
    border-radius: 0 0 10% 10%;
    background: #ffffff;
    overflow: hidden;
    ${mobileAndDown`
        height: 190px;
        width: 212px;
        margin: 0 4px 0 4px;
    `}
`;

export const StyledLoader = styled(ColorRing)`
    position: absolute;
    top: 180px;
    left: 130px;
`;

export const Progress = ({ step, steps = 4 }) => {
    return (
        <ProgressWrapper>
            <ProgressIndicator step={step} steps={steps} />
        </ProgressWrapper>
    );
};

const ProgressWrapper = styled.div`
    width: 65%;
    height: 6px;
    margin: 1rem auto;
    background: #c4c4c4;
    position: relative;
    border-radius: 10px;
`;

const ProgressIndicator = styled.div`
    background: #3b9af8;
    position: absolute;
    height: 6px;
    border-radius: 10px;
    width: ${({ steps }) => 100 / steps}%;
    left: ${({ step, steps }) => Math.min(step, steps - 1) * (100 / steps)}%;
    transition: left 0.5s cubic-bezier(0.65, 0, 0.35, 1);
`;

export const TextBox = styled.div`
    font-family: SF Pro Display, Suisse-Regular;
    background: rgba(229, 229, 229, 0.67);
    border-radius: 10px 10px;
    padding: 1rem;
    margin: 0.5rem 0;
    white-space: pre-wrap;
    font-size: 24px;
`;

export const StatusText = styled.h3`
    font-family: SF Pro Display, Suisse-Regular;
    font-weight: bold;
    font-size: 32px;
`;

export const PhoneContainer = styled.div`
    width: full;

    ${mobileAndDown`
        display: flex;
        width: full;
        height: 730px;
        justify-content: center;
        align-items: flex-end;
        margin-top: -30vh;
    `}
`;

export const PhoneImage = styled.img`
    width: 300px;
    height: 600px;
    border: none;
    padding-left: 10vw;
    margin-top: 5vh;
    z-index: 50;
    ${tabletAndDown`
        padding-left: 5vh;
        margin: 0 auto;
        `};
    ${mobileAndDown`
        padding-left: 0;
        height: 500px;
        width: 250px;
        transform: translateY(calc(320px - 70vw));
    `};
`;

export const TipStepText = styled.div`
    width: 40vw;
    height: 100vh;
    margin-bottom: 30vh;
    font-size: 52px;
    letter-spacing: -0.03em;
    color: white;
    font-family: Circular-Book;
    display: -webkit-flex;
    display: flex;
    align-items: center;
    opacity: 0;
    transition: opacity 0.5s ease-out;
    &.active {
        opacity: 1;
    }
    ${tabletAndDown`
        margin-left: 5vh;
        `}
    ${mobileAndDown`
        margin-left: 0vh;
        font-size: 24px;
        width: auto;
        text-align: center;
        justify-content: center;
        padding-top: 16vh;
        align-items: flex-start;
        order: 1;
        &#text4 {
            font-size: 20px;
        }
    `}
`;

export const TipSpan = styled.span`
    display: inline-block;
    text-align: center;
    background: linear-gradient(
        -60deg,
        #fff 10%,
        rgba(59, 214, 248, 1) 40%,
        rgba(59, 154, 248, 1) 60%,
        #fff 90%
    );
    background-size: 200% auto;
    color: #fff;
    background-clip: text;
    text-fill-color: transparent;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;

    animation: shine 3s linear infinite;
    @keyframes shine {
        to {
            background-position: 200% center;
        }
    }
`;

export const Title = styled.h1`
    display: inline-block;
    text-overflow: auto;
    overflow: hidden;
    font-family: Circular-Bold;
    font-size: 4.5rem;
    letter-spacing: -0.035em;
    width: 80%;
    color: white;
    ${mobileAndDown`
        width: 100%;
        font-size: 2rem;
    `}
`;

export const SubTitle = styled.h2`
    font-family: Circular-Book;
    font-size: 1.25rem;
    margin-left: 0;
    margin-right: 0;
    width: 80%;
    color: #ececec;
    ${mobileAndDown`
        width: 100%;
        font-size: 1.2rem;
    `}
`;

export const TipTextContainer = styled.div`
    margin-left: 40vw;
    ${mobileAndDown`
        margin-left: 0;
        padding-top: 10vh;
    `}
`;
